import { render } from "./VerifyRegister.vue?vue&type=template&id=ce90f3f0"
import script from "./VerifyRegister.vue?vue&type=script&lang=js"
export * from "./VerifyRegister.vue?vue&type=script&lang=js"

import "./VerifyRegister.vue?vue&type=style&index=0&id=ce90f3f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__